import React from 'react';
import { ImageContainer, BackgroundImage, ContentOverlay, Container, Title, SubTitle } from '../styles/BackgroundImageStyle'
import {
    NewsSectionContainer,
    NewsGrid,
    NewsCard,
    NewsImageContainer,
    NewsImage,
    NewsLabel,
    NewsContent,
    NewsTitle,
    NewsLink,
    NewsDescription,
    NewsFooter,
  } from '../styles/InTheNewsStyles'

const newsData = [
    {
        id: 1,
        title: "Why Are People Investing in Luxury Homes in Risk Zones?",
        description: "Despite increasing risks of flooding and erosion, high-end properties in these areas continue to attract buyers.",
        category: "press",
        source: "Real Estate Insights",
        date: "December 20, 2024",
        image: "/assets/images/house1.avif"
    },
    {
        id: 2,
        title: "The Future of Smart Homes: Revolutionizing Real Estate",
        description: "With the rise of IoT devices, smart homes are becoming more popular, and they're reshaping the real estate market.",
        category: "news",
        source: "Tech Real Estate Daily",
        date: "December 19, 2024",
        image: "/assets/images/img1.jpg"
    },
    {
        id: 3,
        title: "How Remote Work is Changing Housing Demand",
        description: "The shift to remote work is increasing the demand for homes in suburban and rural areas as people seek more space.",
        category: "blog",
        source: "Work From Home Times",
        date: "December 18, 2024",
        image: "/assets/images/img2.jpg"
    },
    {
        id: 4,
        title: "Real Estate Investment Tips for 2025",
        description: "Experts share their top advice for investing in real estate in the upcoming year, focusing on emerging markets and trends.",
        category: "guide",
        source: "Investor's Hub",
        date: "December 17, 2024",
        image: "/assets/images/house2.avif"
    },
    {
        id: 5,
        title: "The Impact of Rising Interest Rates on Housing Prices",
        description: "How increased interest rates are affecting property prices and what buyers should expect in the coming months.",
        category: "news",
        source: "Housing Market Weekly",
        date: "December 16, 2024",
        image: "/assets/images/img3.jpg"
    },
    {
        id: 6,
        title: "Sustainable Architecture: A Growing Trend in Luxury Real Estate",
        description: "Sustainable and eco-friendly designs are becoming a top priority in luxury homes, attracting environmentally-conscious buyers.",
        category: "press",
        source: "Eco Homes Today",
        date: "December 15, 2024",
        image: "/assets/images/img4.jpg"
    }
];

const InTheNews = () => {
    return (
        <Container>
            <ImageContainer>
                {/* Background Image */}
                <BackgroundImage
                src="/assets/images/inTheNews.jpg"
                alt="background-image"
                />
                {/* Content Overlay */}
                <ContentOverlay>
                <Title>In The News</Title>
                <SubTitle>See our latest press mentions.</SubTitle>
                </ContentOverlay>
            </ImageContainer>
        

            {/* News Section */}
            <NewsSectionContainer>
                <NewsGrid>
                    {newsData.map((news) => (
                    <NewsCard key={news.id}>
                        {/* News Image */}
                        <NewsImageContainer>
                        <NewsImage src={news.image} alt={news.category} />
                        {/* Label */}
                        <NewsLabel>{news.category}</NewsLabel>
                        </NewsImageContainer>

                        {/* News Content */}
                        <NewsContent>
                        <NewsLink href="#home">
                            <NewsTitle>{news.title}</NewsTitle>
                        </NewsLink>
                        <NewsDescription>{news.description}</NewsDescription>
                        <NewsFooter>
                            {news.source} | <span>{news.date}</span>
                        </NewsFooter>
                        </NewsContent>
                    </NewsCard>
                    ))}
                </NewsGrid>
            </NewsSectionContainer>
        </Container>
    );
};

export default InTheNews;
